import { FieldValidationError } from '../../../types/form/field-validation-error';
export const getRegexFormatValidationRule = (regex) => {
    return data => {
        const isValid = typeof data === 'string' && regex.test(data);
        if (!isValid) {
            return FieldValidationError.Format;
        }
    };
};
//# sourceMappingURL=regex-format-validation-rule.js.map